<script setup lang="ts">
interface ActivityDescriptionFacilitiesProps {
  facilities: string[];
}

const props = defineProps<ActivityDescriptionFacilitiesProps>();
</script>

<template>
  <div class="activity-description-facilities">
    <span class="title">{{ $t('planner.facilities') }}</span>
    <ul class="facilities-list">
      <li v-for="facility in props.facilities" :key="facility" class="facility">
        {{ facility }}
      </li>
    </ul>
  </div>
</template>
